module.exports = __webpack_public_path__ + "static/lungo@2x-bdf43c93a446de05897ef2b79770bc6a.png";